/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）、advertisingservice.html。
 * Section 3：cj-multi-platform 8 平台 Agency Ad Accounts 卡片网格（PC 4 列 / iPad 2 列 / 移动 1 列）。
 * 注意事项：卡片文案（h3/p/alt）经 ConstantsContext 取词，品牌色与 logo 图片为视觉资产保留在组件内。
 * 260714 第13次补充追加(需求⑤)：applovin/bing/taboola/outbrain 原远程 cdn.simpleicons.org slug 不存在(404)，
 *   与 PlatformMarquee 一致改用本地资源 asset/images/advertisingservice/*.png；meta/google/tiktok/snapchat 保留可用 simpleicons。
 */
import React, { useContext } from 'react';
import ConstantsContext from './ConstantsContext';
import { mix } from '../colorMix';
import applovinLogo from 'asset/images/advertisingservice/applovin.png';
import bingLogo from 'asset/images/advertisingservice/bing.png';
import taboolaLogo from 'asset/images/advertisingservice/taboola.png';
import outbrainLogo from 'asset/images/advertisingservice/outbrain.png';
// 260715 第17次补充(需求㊷)：meta/google/tiktok/snapchat 原 cdn.simpleicons.org 外链改为本地 svg，不再引用外部链接
import metaLogo from 'asset/images/advertisingservice/meta.svg';
import googleLogo from 'asset/images/advertisingservice/google.svg';
import tiktokLogo from 'asset/images/advertisingservice/tiktok.svg';
import snapchatLogo from 'asset/images/advertisingservice/snapchat.svg';

// 视觉资产（品牌色 / logo）顺序与 MULTI_PLATFORM.cards 一一对应
var CARD_VISUALS = [
  { brand: '#0866ff', soft: 'rgba(8,102,255,.20)', logo: metaLogo },
  { brand: '#4285f4', soft: 'rgba(66,133,244,.20)', logo: googleLogo },
  { brand: '#00a4ef', soft: 'rgba(0,164,239,.18)', logo: bingLogo },
  { brand: '#25f4ee', soft: 'rgba(37,244,238,.16)', logo: tiktokLogo },
  { brand: '#9d7cff', soft: 'rgba(157,124,255,.20)', logo: applovinLogo },
  { brand: '#fffc00', soft: 'rgba(255,252,0,.15)', logo: snapchatLogo },
  { brand: '#1769ff', soft: 'rgba(23,105,255,.20)', logo: taboolaLogo },
  { brand: '#e55b86', soft: 'rgba(229,91,134,.20)', logo: outbrainLogo },
];

// 由品牌主色预算派生 CSS 变量（等价原 less 的 color-mix）
function brandVars(brand, soft) {
  if (!brand) return { '--brand-soft': soft };
  return {
    '--brand': brand,
    '--brand-soft': soft,
    '--brand-bd': mix(brand, 'transparent', 28),       // logo 描边
    '--brand-bg': mix(brand, 'transparent', 12),       // logo 底色
    '--brand-arrow-bd': mix(brand, 'transparent', 34), // hover 箭头描边
    '--brand-arrow-bg': mix(brand, 'transparent', 10), // hover 箭头底色
    '--brand-link': mix(brand, '#243142', 72),         // 链接文字（压暗）
  };
}

function MultiPlatform() {
  const { MULTI_PLATFORM } = useContext(ConstantsContext);
  return (
    <section className="cj-multi-platform">
      <div className="cj-multi-platform__container">
        <div className="cj-multi-platform__header">
          <div className="cj-multi-platform__eyebrow">{MULTI_PLATFORM.eyebrow}</div>
          <h2 className="cj-multi-platform__title">
            {MULTI_PLATFORM.title} <span className="accent">{MULTI_PLATFORM.titleAccent}</span>
          </h2>
          <p className="cj-multi-platform__description">{MULTI_PLATFORM.description}</p>
        </div>

        <div className="cj-multi-platform__grid" id="platform-accounts">
          {MULTI_PLATFORM.cards.map((c, i) => {
            var v = CARD_VISUALS[i] || {};
            return (
              <article className="cj-platform-card" key={c.h3} style={brandVars(v.brand, v.soft)}>
                <div className="cj-platform-card__top">
                  {/* 260716 需求(65)：去掉 cj-platform-card__arrow 右上角箭头 */}
                  <div className="cj-platform-card__logo-wrap">
                    <img className="cj-platform-card__logo" src={v.logo} alt={c.alt} loading="lazy" />
                  </div>
                </div>
                <h3>{c.h3}</h3>
                <p>{c.p}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default MultiPlatform;
